/**
 * Guided tour for the Punch Lists detail view (``PunchListDetail``).
 *
 * This standalone detail tour only runs when the user lands on a detail
 * page *without* having seen the {@link combined.ts | combined tour}
 * (which already covers the same content). The combined tour is the
 * primary way users meet this page; the standalone tour catches the
 * direct-URL / late-creation cases.
 *
 * Importing this module registers the tour as a side effect.
 */
import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import {
  attachmentsStep,
  descriptionStep,
  headerActionsStep,
  metadataStep,
  peopleStep,
} from './steps';

export const PUNCH_LISTS_DETAIL_TOUR_ID = 'punch_lists.detail';

registerTour({
  id: PUNCH_LISTS_DETAIL_TOUR_ID,
  name: 'Punch List Item',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.PUNCH_LISTS.id,
  steps: [
    {
      id: 'welcome',
      title: 'Punch list item details',
      body:
        'Here\u2019s everything tied to this punch list item — context, ' +
        'files, and the people responsible.',
    },
    headerActionsStep,
    metadataStep,
    descriptionStep,
    attachmentsStep,
    peopleStep,
  ],
});
